<template>
  <v-dialog
    v-model="dialog"
    max-width="450px"
  >
    <material-card
      :offset="10"
      :full-width="true"
      color="green"
      title="Kpi Category"
      text="Edit Kpi Category"
      class="mb-0"
    >
      <form v-if="dialog">
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="category.name"
                v-validate="'required'"
                :error-messages="errors.collect('name')"
                data-vv-name="name"                
                label="Name"
              />
            </v-col>
          </v-row>
        </v-container>
      </form>

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="setDialog(false)"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="success"          
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    inject: ['$validator'],
    data () {
      return {
        dialog: false,
        progressing: false,
        category: null,
      }
    },
    methods: {
      emitUpdatedEvent (status) {
        this.$emit('updated', this.category, status)
      },
      setProgressing (status) {
        this.progressing = status
      },
      setDialog (status) {
        this.dialog = status
      },
      toggleDialog (category) {
        this.category = { ...category }
      
        this.setDialog(true)
      },
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.setProgressing(true)

            this.$api.kpiCategories().update(this.category.id, { name: this.category.name })
              .then(response => {
                if (response.status >= 200 && response.status < 300) {
                  this.$emit('updated', this.category)
                  this.$snack({ message: response.data.status })
                
                  this.setDialog(false)
                }
              })
              .catch(() => {})
              .then(() => {
                this.setProgressing(false)
              })
          })
      },
    },
  }
</script>
